import { useState } from 'react';

export const PivotSection = ({ pivotData }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleTabClick = (index) => {
    setActiveIndex(index);
  };
  

  return (
    <div className="custom-tabbed-section mt-8">
      <div className="flex space-x-8 overflow-x-auto no-scrollbar justify-start md:justify-center">
        {pivotData.length > 1 && pivotData.map((pane, index) => (
          <button
            key={index}
            className={`text-md font-medium mb-8 whitespace-nowrap flex-shrink-0 pb-2 border-b-2 border-transparent transition-all duration-300 ${
              activeIndex === index
                ? "text-is2-yellow-500 border-b-2 !border-is2-yellow-500"
                : "text-is2-gray-body"
            }`}
            onClick={() => handleTabClick(index)}
          >
            <span className="flex items-center gap-2">
              {pane.tabHeaderIcon && (
                <img
                  src={pane.tabHeaderIcon.imageUrl}
                  alt={pane.tabHeaderIcon.alt}
                  className={`w-5 h-5 object-contain ${activeIndex === index ? "[filter:brightness(0)_saturate(100%)_invert(55%)_sepia(65%)_saturate(1600%)_hue-rotate(2deg)]" : "[filter:brightness(0)_saturate(100%)_invert(24%)_sepia(96%)_saturate(1437%)_hue-rotate(210deg)]"}`}
                />
              )}
              {pane.tabHeaderTitle}
            </span>
          </button>
        ))}
      </div>
      <div className="relative">
        {pivotData.map((pane, index) => (
          <div
            key={index}
            className={`transition-opacity duration-500 ${
              activeIndex === index
                ? "opacity-100"
                : "opacity-0 invisible absolute inset-0 pointer-events-none"
            }`}
          >
            {activeIndex === index && pane.render()}
          </div>
        ))}
      </div>
    </div>
  );
};
